<template>
  <div class="invite">
    <div class="invite_bgup">
      <div class="invite_rewards">
        <div class="rewards_item" v-for="(item,index) in prizeList" :key="index">
          <p class="invite_num">邀请{{ item.inviteNumber }}人</p>
          <div class="bgout" @click="receive(item.prizeId)">
            <img src="../assets/images/invitefriends/newInvite/Slicing/qp.png" alt>
            <div class="bgin">
              <img :src="item.itemImg" alt>
            </div>
          </div>
          <p class="rewards_name">{{ item.prizeName }}</p>
        </div>
      </div>
      <Motial :isShow="isShow" :message="message" @click="close"></Motial>
    </div>
    <InviteInfo @click="share" :userid="userid" :inviteNumber="inviteNumber" :inviteSuccessNumber="inviteSuccessNumber"></inviteInfo>
  </div>
</template>
<script>
import axios from "axios"
import InviteInfo from  "../Component/InviteInfo"
import Motial from "../Component/Motial"
export default {
  name: "invite",
  data() {
    return {
      userid: "",
      token: "",
      nickname: "",
      inviteNumber: "",
      inviteSuccessNumber: "",
      prizeList: [],
      isShow: false,
      message: "",
      platform: ""
    };
  },
  components: {
    InviteInfo,
    Motial
  },
  created() {
    document.getElementsByTagName("title")[0].innerText = "邀请好友";
    var u = navigator.userAgent,
      app = navigator.appVersion;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.platform = 1;
    } else if (isiOS) {
      this.platform = 2;
    } else {
      this.platform = 1;
    }
    //  与原生app 交互的部分
    setTimeout(() => {
      this.$bridge.callhandler(
        {
          action: "get",
          object: "userinfo"
        },
        res => {
          const jsonObj = JSON.parse(res);
          this.token = jsonObj.token;
          this.userguid = jsonObj.userguid;
          this.nickname = jsonObj.nickname;
          this.invite();
        }
      );
    }, 300);
  },
  methods: {
    invite() {
      axios({
        url: this.$interfaces.invite,
        method: "post",
        data: {
          token: this.token,
          userGuid: this.userguid
        },
        dataType: "json"
      })
        .then(res => {
          this.inviteSuccessNumber = res.data.data.inviteSuccessNumber;
          this.inviteNumber = res.data.data.inviteNumber;
          this.prizeList = res.data.data.prizeList;
          this.userid = res.data.data.userId;
        })
        .catch(err => {
          console.log(err);
        });
    },
    share() {
      this.appShare();
    },
    appShare() {
      this.$bridge.callhandler({
        action: "open",
        object: "share",
        param: {
          title: this.nickname + "," + "邀请您来玩我是谜",
          desc: "我是谜,年轻人都爱玩的社交推理app",
          image:
            "https://woshimiimage.mvoicer.com/image/item/showImg/1546842407308?imageMogr2/thumbnail/300x300",
          url: "http://sharehtml.xiyacs.com/share/" + this.userid 
        }
      });
    },
    receive(prizeId) {
      axios({
        url: this.$interfaces.saleReceive,
        method: "post",
        data: {
          token: this.token,
          userGuid: this.userguid,
          prizeId: prizeId,
          platform: this.platform
        },
        dataType: "json"
      })
        .then(res => {
          this.message = res.data.message;
          if (res.data.success == true) {
            this.isShow = true;
          } else {
            this.isShow = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    close() {
      this.isShow = false;
    }
  },
  mounted() {}
};
</script>
<style scoped>
.invite {
  width: 100%;
  height: 100%;
}
.invite .invite_bgup {
  position: relative;
  height: 31.75rem;
  background: url("../assets/images/invitefriends/newInvite/Slicing/bgUp.png")
    no-repeat left top;
  background-size: cover;
}
.invite .invite_bgup .invite_rewards {
  position: absolute;
  top: 18.375rem;
  left: 1.25rem;
  height: 10.9rem;
  width: 16.275rem;
}
.invite .invite_bgup .invite_rewards .rewards_item {
  float: left;
  position: relative;
  width: 5.425rem;
  height: 4.875rem;
  margin-bottom: 1.35rem;
  text-align: center;
}
.invite .invite_bgup .invite_rewards .rewards_item .invite_num {
  text-align: center;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.45rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #f2f2f2;
}
.invite .invite_bgup .invite_rewards .rewards_item .bgout {
  position: relative;
  display: flex;
  justify-content: center;
  align-self: center;
  margin: 0 auto;
  width: 3.2rem;
  height: 3.15rem;
  margin-bottom: 0.575rem;
 
}
.invite .invite_bgup .invite_rewards .rewards_item .bgout .bgin {
  position: absolute;
  top: 15%;
  left: 15%;
  width: 2.275rem;
  height: 2.325rem;
  overflow: hidden;
  border-radius: 50%;
}
.invite .invite_bgup .invite_rewards .rewards_item .bgout img,
.invite .invite_bgup .invite_rewards .rewards_item .bgout .bgin img {
  width: 100%;
  height: 100%;
}
.invite .invite_bgup .invite_rewards .rewards_item .rewards_name {
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.45rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.675rem;
  letter-spacing: 0rem;
  color: #f2f2f2;
  text-align: center;
}

</style>





// WEBPACK FOOTER //
// src/components/Invite.vue